<template>
	<form @submit="apply">
		<div class="card bg-light my-3">
			<div class="card-body form-row p-2">
				<div class="col-auto">
					<select
						class="form-control"
						v-model="fieldInput"
					>
						<option
							disabled
							v-if="!applied"
							:value="null"
						>Select a field</option>
						<option
							v-for="f in fields.filter(f => !f.nofilter)"
							:key="f.field"
							:value="f"
						>{{ f.label }}</option>
					</select>
				</div>
				<div class="col-auto">
					<select
						class="form-control"
						:disabled="!fieldInput"
						v-model="operatorInput"
					>
						<option
							v-for="o in operatorOptions"
							v-html="o.label"
							:disabled="!enabledOperators.includes(o.value)"
							:key="o.value"
							:value="o.value"
						></option>
					</select>
				</div>
				<FieldInput class="col" :disabled="!fieldInput" :field="fieldInput" v-model="argumentInput" />
				<div class="col-auto">
					<button
						class="btn btn-primary mx-1"
						:disabled="!fieldInput || !argumentInput"
						role="submit"
					>
						<b-icon icon="filter"></b-icon>
					</button>
					<button
						class="btn btn-danger mx-1"
						@click="remove"
						:disabled="!applied"
					>
						<b-icon icon="trash"></b-icon>
					</button>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import { inputType } from '../util'
import FieldInput from './FieldInput'

export default {
	props: ['applied', 'condition', 'fields', 'index'],
	components: { FieldInput },
	data() {
		const { field, operator, argument } = this.condition || {}
		return {
			// input
			fieldInput: field || null,
			operatorInput: operator || '$eq',
			argumentInput: argument,
			// options
			operatorOptions: [
				{ value: '$eq', label: 'equals (=)' },
				{ value: '$ne', label: 'is not (&ne;)' },
				{ value: '$gt', label: 'is greater than (&gt;)' },
				{ value: '$gte', label: 'is at least (&ge;)' },
				{ value: '$lt', label: 'is less than (&lt;)' },
				{ value: '$lte', label: 'is at most (&le;)' },
				{ value: '$regex', label: 'matches regex' },
			],
		}
	},
	computed: {
		inputType() {
			return inputType(this.fieldInput)
		},
		enabledOperators() {
			const t = inputType(this.fieldInput)
			return this.operatorOptions
				.map((o) => o.value)
				.filter((value) => {
					if (
						['$gt', '$gte', '$lt', '$lte'].includes(value) &&
						['select'].includes(t)
					) {
						return false
					}
					if (
						['$regex'].includes(value) &&
						['number', 'select'].includes(this.inputType)
					) {
						return false
					}
					return true
				})
		},
	},
	watch: {
		fieldInput(f) {
			if (!f) return
			if (f.type === 'number' && this.operatorInput === '$regex') {
				this.operatorInput = '$eq'
			}
			if (f.type === 'enum' && f.values) {
				this.argumentInput = f.values[0]
			}
		},
	},
	methods: {
		apply(e) {
			e.preventDefault()
			this.$emit(
				'apply',
				{
					field: this.fieldInput,
					operator: this.operatorInput,
					argument: this.argumentInput,
				},
				this.index
			)
			if (!this.applied) {
				this.fieldInput = null
				this.operatorInput = '$eq'
				this.argumentInput = null
			}
		},
		remove() {
			this.$emit('remove', this.index)
		},
	},
}
</script>

<style scoped>
select option[disabled] {
	color: #ccc;
}
</style>
